import { createStyles, Theme, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { PresetType } from '../../store/types';
import { CustomControlsContainer } from './customControls';
import { PresetNavigatorContainer } from './PresetNavigatorContainer';
import { PresetsContainer } from './PresetsContainer';

export interface NavbarProps {
  preset: PresetType;
  filters: { text: string; active: boolean };
}

export interface NavbarActions {
  openFilters: () => void;
  clearFilters: () => void;
}

interface StylesProps {
  classes: {
    chevron: string;
    filtersButton: string;
  };
}

const styles = (theme: Theme) =>
  createStyles({
    chevron: {
      padding: '4px',
      marginLeft: '4px'
    },
    filtersButton: {
      minWidth: '100px',
      maxWidth: '300px'
    }
  });

type AllProps = NavbarProps & NavbarActions & StylesProps;

class Navbar extends React.PureComponent<AllProps> {
  public render() {
    const filtersBtnColor = this.props.filters.active ? 'secondary' : 'primary';
    return (
      <div className="ap-navbar">
        <Button
          size="small"
          onClick={this.props.openFilters}
          variant="outlined"
          color={filtersBtnColor}
          className={this.props.classes.filtersButton}
        >
          <Typography noWrap={true} color={filtersBtnColor}>
            {this.props.filters.text}
          </Typography>
        </Button>
        {this.props.filters.active && (
          <IconButton onClick={this.props.clearFilters} className={this.props.classes.chevron}>
            <SvgIcon>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </SvgIcon>
          </IconButton>
        )}
        <PresetsContainer />
        {this.props.preset === PresetType.Custom ? <CustomControlsContainer /> : <PresetNavigatorContainer />}
      </div>
    );
  }
}

export default withStyles(styles)(Navbar);



// WEBPACK FOOTER //
// ./src/components/navbar/Navbar.tsx